import { action, Action } from 'easy-peasy';
import { TemplateTypeItem } from '@/services/material/index.d';

export interface ITemplateCollapse {
    categories: TemplateTypeItem[];
    setCategories: Action<ITemplateCollapse, TemplateTypeItem[]>;
}

export const templateCollapseModel: ITemplateCollapse = {
    // 模板搜索的分类聚合，数据来源接口，初始化不需要重置
    categories: [],
    setCategories: action((state, list) => {
        state.categories = list;
    }),
};
